<template>
  <div class="bottom-nav">
    <span><slot></slot></span>
    <div class="nav-link-wrapper">
      <a @click="navigateNext" href="javascript:">
        <font-awesome-icon icon="chevron-right"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNavigation',
  props: ['link'],
  methods: {
    navigateNext() {
      this.$router.push(this.link);
      window.scrollTo(0, 0);
    },
  },
};
</script>
